import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import axios from 'axios';
import { querySiteTree, sceneQueryById, sceneAdd, querySelectSiteIds } from '@/api/api';
export default {
  name: 'senceConfig',
  data: function data() {
    return {
      columns: [{
        dataIndex: 'scene_id',
        colName: 'scene_id',
        title: '场景ID',
        align: 'center'
      }, {
        dataIndex: 'name',
        colName: 'name',
        title: '场景名称',
        align: 'center'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      dataSource: [],
      loading: false,
      bindShow: false,
      autoExpandParent: true,
      checkedKeys: [],
      selectedKeys: [],
      treeData: [],
      editId: null,
      selectRow: {}
    };
  },
  mounted: function mounted() {
    this.getData();
    this.loadTree();
  },
  watch: {
    checkedKeys: function checkedKeys(val) {
      console.log('onCheck', val);
    },
    bindShow: function bindShow(val) {
      if (!val) {
        this.clearDisabled(this.treeData);
      }
    }
  },
  methods: {
    // 设置树禁用
    setDisabled: function setDisabled(treeData, list) {
      var _this = this;

      treeData.forEach(function (item) {
        if (item.children) {
          _this.setDisabled(item.children, list);
        } else {
          list.forEach(function (userKey) {
            if (item.key == userKey) {
              item.disabled = true;
            }
          });
        }
      });
      this.$forceUpdate();
    },
    clearDisabled: function clearDisabled(treeData) {
      var _this2 = this;

      treeData.forEach(function (item) {
        if (item.children) {
          _this2.clearDisabled(item.children);
        } else {
          item.disabled = false;
        }
      });
    },
    getData: function getData() {
      var _this3 = this;

      var appKey = window.localStorage.getItem('appKey') != 'null' && window.localStorage.getItem('appKey') != '' ? window.localStorage.getItem('appKey') : 'yesep_env';
      var appUrl = window.localStorage.getItem('sceneUrl') != 'null' && window.localStorage.getItem('sceneUrl') != '' ? window.localStorage.getItem('sceneUrl') : 'https://www.skyray-water.com:4001/3d/api/scenes/';
      axios.get(appUrl + appKey).then(function (res) {
        // axios.get('/3d/api/scenes/yesep_iws').then((res) => {
        _this3.dataSource = res.data.data;
      });
    },
    getSenceSites: function getSenceSites(id) {
      var _this4 = this;

      sceneQueryById(id).then(function (res) {
        if (res.success) {
          if (res.result) {
            _this4.checkedKeys = res.result.sites.split(',');
            _this4.editId = res.result.id;
          } else {
            _this4.checkedKeys = [];
            _this4.editId = null;
          }
        } else {
          _this4.checkedKeys = [];
          _this4.editId = null;
        }
      });
    },
    getDisableSenceSites: function getDisableSenceSites(id) {
      var _this5 = this;

      querySelectSiteIds(id).then(function (res) {
        if (res.success) {
          if (res.result && res.result.length > 0) {
            _this5.setDisabled(_this5.treeData, res.result);
          }
        }
      });
    },
    loadTree: function loadTree() {
      var _this6 = this;

      querySiteTree({
        addrType: 1
      }).then(function (res) {
        if (res.success) {
          _this6.treeData = _toConsumableArray(res.result);
        }
      });
    },
    handleBind: function handleBind(row) {
      this.getSenceSites(row.scene_id);
      this.getDisableSenceSites(row.scene_id);
      this.selectRow = row;
      this.bindShow = true;
    },
    handleOk: function handleOk() {
      var _this7 = this;

      var siteList = [];
      this.checkedKeys.forEach(function (item) {
        if (item.indexOf('_') == -1) {
          siteList.push(item);
        }
      });
      sceneAdd({
        id: this.editId,
        sceneId: this.selectRow.scene_id,
        sites: siteList.join(',')
      }).then(function (res) {
        if (res.success) {
          _this7.$message_custom(res.message);

          _this7.bindShow = false;
        }
      });
    },
    onCheck: function onCheck(checkedKeys) {
      this.checkedKeys = checkedKeys;
    }
  }
};